import React, { useState, useEffect } from 'react';
import './App.css';

// Logo Component
const Logo = () => (
  <img 
    src="https://static.kilimax.com/enterprise_null/company_null/2026/06/28/c7144f5f6b3c45eebe9b1e797904c216.jpg" 
    alt="FundiSwift Logo" 
  />
);

// Material Icon Component
const Icon = ({ name, className = '' }) => (
  <span className={`material-symbols-outlined ${className}`}>{name}</span>
);

// Modal Component
const Modal = ({ isOpen, onClose, title, icon, children }) => {
  if (!isOpen) return null;
  
  return (
    <div className={`modal-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header-custom">
          <h5>
            <Icon name={icon} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
            {title}
          </h5>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body-custom">
          {children}
        </div>
      </div>
    </div>
  );
};

// Quote Form Component
const QuoteForm = ({ onClose }) => {
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };
  
  if (submitted) {
    return (
      <div className="form-success">
        <Icon name="check_circle" />
        <h4>Quote Request Sent!</h4>
        <p>Thank you for contacting FundiSwift. We'll get back to you within 30 minutes.</p>
        <button className="btn-primary-green" onClick={onClose} style={{ border: 'none', cursor: 'pointer' }}>
          Close
        </button>
      </div>
    );
  }
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Full Name *</label>
          <input type="text" className="form-control" name="name" placeholder="Your full name" required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Phone Number *</label>
          <input type="tel" className="form-control" name="phone" placeholder="+254 7XX XXX XXX" required />
        </div>
        <div className="col-12">
          <label className="form-label">Email Address *</label>
          <input type="email" className="form-control" name="email" placeholder="your@email.com" required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Service Type *</label>
          <select className="form-select" name="service" required>
            <option value="">Select a service</option>
            <option>Plumbing</option>
            <option>Electrical</option>
            <option>Cleaning</option>
            <option>Auto Repair</option>
            <option>Carpentry</option>
            <option>CCTV & Security</option>
            <option>Solar Services</option>
            <option>Handyman</option>
            <option>Other</option>
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">Location *</label>
          <input type="text" className="form-control" name="location" placeholder="e.g., Nairobi West" required />
        </div>
        <div className="col-12">
          <label className="form-label">Describe Your Need *</label>
          <textarea className="form-control" name="message" rows="3" placeholder="Tell us what you need help with..." required />
        </div>
        <div className="col-12">
          <button type="submit" className="btn-submit">
            <Icon name="send" style={{ verticalAlign: 'middle', marginRight: '8px' }} />
            Submit Quote Request
          </button>
        </div>
      </div>
    </form>
  );
};

// Provider Form Component
const ProviderForm = ({ onClose }) => {
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };
  
  if (submitted) {
    return (
      <div className="form-success">
        <Icon name="check_circle" />
        <h4>Application Submitted!</h4>
        <p>Thank you for your interest. Our team will review and contact you within 24 hours.</p>
        <button className="btn-primary-green" onClick={onClose} style={{ border: 'none', cursor: 'pointer' }}>
          Close
        </button>
      </div>
    );
  }
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-12">
          <label className="form-label">Provider Full Name *</label>
          <input type="text" className="form-control" name="provider_name" placeholder="Enter your full name" required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Telephone Number *</label>
          <input type="tel" className="form-control" name="provider_phone" placeholder="+254 7XX XXX XXX" required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Email Address *</label>
          <input type="email" className="form-control" name="provider_email" placeholder="your@email.com" required />
        </div>
        <div className="col-12">
          <label className="form-label">Service Category *</label>
          <select className="form-select" name="provider_service" required>
            <option value="">Select your service</option>
            <option>Plumbing</option>
            <option>Electrical</option>
            <option>Cleaning</option>
            <option>Auto Repair</option>
            <option>Carpentry</option>
            <option>CCTV & Security</option>
            <option>Solar Services</option>
            <option>Handyman</option>
            <option>Other</option>
          </select>
        </div>
        <div className="col-12">
          <button type="submit" className="btn-submit">
            <Icon name="send" style={{ verticalAlign: 'middle', marginRight: '8px' }} />
            Submit Application
          </button>
        </div>
      </div>
    </form>
  );
};

// Login Selection Modal
const LoginSelectionModal = ({ isOpen, onClose, onSelectType }) => {
  const userTypes = [
    { type: 'admin', icon: 'admin_panel_settings', title: 'Admin User', desc: 'Dashboard access for administrators', gradient: 'var(--primary-green), var(--forest-green)' },
    { type: 'provider', icon: 'storefront', title: 'Provider User', desc: 'Manage your service business', gradient: 'var(--gold-light), var(--gold)' },
    { type: 'handyman', icon: 'handyman', title: 'Handyman User', desc: 'Access your job assignments', gradient: '#4A90A4, #357ABD' },
  ];
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Login to FundiSwift" icon="login">
      <p className="text-center text-muted mb-4">Select your account type to sign in</p>
      <div className="login-options">
        {userTypes.map(({ type, icon, title, desc, gradient }) => (
          <div 
            key={type} 
            className="login-option" 
            onClick={() => onSelectType(type)}
          >
            <div className="login-icon" style={{ background: `linear-gradient(135deg, ${gradient})` }}>
              <Icon name={icon} />
            </div>
            <div className="login-info">
              <h6>{title}</h6>
              <p>{desc}</p>
            </div>
            <Icon name="chevron_right" className="arrow" />
          </div>
        ))}
      </div>
      <div className="text-center mt-4 pt-3 border-top">
        <p className="text-muted mb-2">Don't have an account?</p>
        <span className="btn-outline-green" style={{ padding: '8px 24px', fontSize: '0.9rem', cursor: 'pointer' }}>
          Register Here
        </span>
      </div>
    </Modal>
  );
};

// Navbar Component
const Navbar = ({ onLoginClick, onQuoteClick, onProviderClick }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };
  
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <div className="nav-holder">
          <a className="navbar-brand" href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
            <Logo />
          </a>
          <button className="navbar-toggler" onClick={() => setMenuOpen(!menuOpen)}>
            <Icon name="menu" style={{ color: 'var(--primary-green)', fontSize: '32px' }} />
          </button>
          <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a className="nav-link active" href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); }}>How It Works</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#categories" onClick={(e) => { e.preventDefault(); scrollToSection('categories'); }}>Categories</a>
              </li>
            </ul>
            <div className="mobile-nav-actions d-lg-none">
              <span className="btn-outline-green w-100 text-center" onClick={onLoginClick}>Login</span>
              <button className="btn-quote w-100" onClick={onQuoteClick}>Get a Quote</button>
            </div>
          </div>
          <div className="nav-actions d-none d-lg-flex">
            <span className="nav-link-text" onClick={onProviderClick}>Become a Provider</span>
            <span className="btn-login" onClick={onLoginClick}>Login</span>
            <button className="btn-quote" onClick={onQuoteClick}>Get a Quote</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

// Hero Section
const HeroSection = ({ onExploreServices }) => (
  <section className="hero-section" id="home">
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-6">
          <div className="trust-pill">
            <Icon name="verified" />
            <span>#1 Trusted Service Platform in Kenya</span>
          </div>
          <h1 className="hero-title">
            All You Need,<br />
            <span className="text-gradient">Under One Roof.</span>
          </h1>
          <p className="hero-subtitle">
            From plumbing to electrical, cleaning to auto repair — FundiSwift connects you with verified professionals for every home service need. One platform, infinite solutions.
          </p>
          <div className="hero-buttons">
            <span className="btn-primary-green" onClick={onExploreServices}>
              Explore Services <i className="fas fa-arrow-right ms-2"></i>
            </span>
            <span className="btn-outline-green" onClick={() => document.getElementById('categories').scrollIntoView({ behavior: 'smooth' })}>
              Browse Categories
            </span>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="hero-image-container">
            <div style={{ 
              width: '100%', 
              height: '450px', 
              background: 'linear-gradient(135deg, var(--primary-green), var(--forest-green))', 
              borderRadius: '30px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              boxShadow: '0 40px 80px rgba(35, 123, 10, 0.25)' 
            }}>
              <div style={{ textAlign: 'center', color: 'white' }}>
                <i className="fas fa-tools" style={{ fontSize: '5rem', opacity: 0.3, marginBottom: '1rem' }}></i>
                <p style={{ fontSize: '1.2rem', fontWeight: 600, opacity: 0.7 }}>All Services in One Place</p>
              </div>
            </div>
            <div className="floating-badge top-rated">
              <div className="badge-icon green"><Icon name="star" /></div>
              <div className="badge-text"><strong>Top Rated</strong><span>4.9/5 Rating</span></div>
            </div>
            <div className="floating-badge verified">
              <div className="badge-icon gold"><Icon name="verified" /></div>
              <div className="badge-text"><strong>Verified Pros</strong><span>Background Checked</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// About Section
const AboutSection = () => (
  <section className="about-section" id="about">
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-6">
          <div className="section-tag">About Us</div>
          <h2 className="section-title">
            Kenya's Most Trusted <span style={{ color: 'var(--primary-green)' }}>Service Platform</span>
          </h2>
          <p>
            FundiSwift is Kenya's leading unified home service marketplace, connecting thousands of customers with verified, reliable professionals for all their service needs. Born from the need to solve the challenge of finding trustworthy service providers, we've built a platform that prioritizes quality, transparency, and customer satisfaction.
          </p>
          <p>
            Our name "Fundi" means skilled craftsperson in Swahili — reflecting our commitment to connecting you with true professionals who take pride in their work.
          </p>
          <div className="row g-4 mt-4">
            <div className="col-6">
              <div className="d-flex align-items-center gap-3">
                <Icon name="verified" style={{ color: 'var(--primary-green)', fontSize: '2rem' }} />
                <div>
                  <strong>Verified Pros</strong>
                  <p className="mb-0 text-muted small">Background-checked professionals</p>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex align-items-center gap-3">
                <Icon name="schedule" style={{ color: 'var(--gold)', fontSize: '2rem' }} />
                <div>
                  <strong>Fast Response</strong>
                  <p className="mb-0 text-muted small">Same-day service available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={{ 
            background: 'linear-gradient(135deg, var(--primary-green), var(--forest-green))', 
            borderRadius: '30px', 
            padding: '3rem', 
            color: 'white', 
            textAlign: 'center' 
          }}>
            <div className="row g-4">
              <div className="col-6">
                <div style={{ fontSize: '2.5rem', fontWeight: 800 }}>10K+</div>
                <div style={{ opacity: 0.8 }}>Happy Customers</div>
              </div>
              <div className="col-6">
                <div style={{ fontSize: '2.5rem', fontWeight: 800 }}>500+</div>
                <div style={{ opacity: 0.8 }}>Verified Pros</div>
              </div>
              <div className="col-6">
                <div style={{ fontSize: '2.5rem', fontWeight: 800 }}>50+</div>
                <div style={{ opacity: 0.8 }}>Service Types</div>
              </div>
              <div className="col-6">
                <div style={{ fontSize: '2.5rem', fontWeight: 800 }}>4.9</div>
                <div style={{ opacity: 0.8 }}>Average Rating</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// How It Works Section
const HowItWorksSection = () => {
  const steps = [
    { icon: 'search', title: 'Browse & Select', desc: 'Explore our wide range of services and categories. Read reviews, compare prices, and choose the professional that fits your needs.' },
    { icon: 'calendar_today', title: 'Book & Schedule', desc: 'Submit your request with details about the job. Choose a convenient date and time. We\'ll match you with the right professional.' },
    { icon: 'task_alt', title: 'Relax & Enjoy', desc: 'Our verified professional arrives on time, completes the job to the highest standards. Pay securely after completion.' },
  ];
  
  return (
    <section className="how-section" id="how-it-works">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-tag">How It Works</div>
          <h2 className="section-title">Get Service in <span style={{ color: 'var(--primary-green)' }}>3 Simple Steps</span></h2>
          <p className="section-subtitle mx-auto">Booking a professional has never been easier.</p>
        </div>
        <div className="row g-4">
          {steps.map((step, index) => (
            <div className="col-lg-4" key={index}>
              <div className="how-step-card">
                <div className="step-number">0{index + 1}</div>
                <div className="step-icon"><Icon name={step.icon} /></div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5">
          <span className="btn-primary-green" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
            Get Started Now <i className="fas fa-arrow-right ms-2"></i>
          </span>
        </div>
      </div>
    </section>
  );
};

// Categories Section
const CategoriesSection = ({ onQuoteClick }) => {
  const categories = [
    { icon: 'plumbing', title: 'Plumbing', desc: 'Pipe repair, installations & leak detection', color: 'green' },
    { icon: 'electrical_services', title: 'Electrical', desc: 'Wiring, repairs & solar installations', color: 'gold' },
    { icon: 'cleaning_services', title: 'Cleaning', desc: 'Deep cleaning, fumigation & laundry', color: 'green' },
    { icon: 'directions_car', title: 'Auto Repair', desc: 'Mechanic services & vehicle maintenance', color: 'gold' },
    { icon: 'construction', title: 'Carpentry', desc: 'Furniture repair, woodwork & fittings', color: 'gold' },
    { icon: 'security', title: 'CCTV & Security', desc: 'Installation, repairs & monitoring', color: 'green' },
    { icon: 'solar_power', title: 'Solar Services', desc: 'Panel installation & maintenance', color: 'gold' },
    { icon: 'handyman', title: 'Handyman', desc: 'General repairs & maintenance', color: 'green' },
  ];
  
  return (
    <section className="categories-section" id="categories">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-tag">Our Categories</div>
          <h2 className="section-title">Popular <span style={{ color: 'var(--primary-green)' }}>Service Categories</span></h2>
          <p className="section-subtitle mx-auto">Browse through our comprehensive range of service categories to find exactly what you need.</p>
        </div>
        <div className="row g-4">
          {categories.map((cat, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="category-card" onClick={onQuoteClick}>
                <div className={`category-icon ${cat.color}`}>
                  <Icon name={cat.icon} />
                </div>
                <h5>{cat.title}</h5>
                <p>{cat.desc}</p>
                <div className="category-arrow">
                  <Icon name="arrow_forward" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = ({ onQuoteClick }) => {
  const services = [
    { icon: 'plumbing', title: 'Emergency Plumbing', desc: '24/7 emergency plumbing services for leaks, blockages, and pipe repairs.', price: 'From KSh 1,500', rating: 4.9, badge: 'Most Popular', color: 'green' },
    { icon: 'electrical_services', title: 'Electrical Wiring', desc: 'Complete electrical wiring services for homes and commercial spaces.', price: 'From KSh 2,000', rating: 4.8, badge: 'Highly Rated', color: 'gold' },
    { icon: 'cleaning_services', title: 'Deep Cleaning', desc: 'Comprehensive home deep cleaning with eco-friendly products.', price: 'From KSh 3,500', rating: 4.9, badge: 'Best Value', color: 'green' },
    { icon: 'directions_car', title: 'Auto Repair & Service', desc: 'Professional mechanic services for all vehicle types and brands.', price: 'From KSh 2,500', rating: 4.7, badge: 'Trending', color: 'gold' },
    { icon: 'solar_power', title: 'Solar Panel Installation', desc: 'Expert solar installation for homes and businesses. Save on bills!', price: 'From KSh 15,000', rating: 4.8, badge: 'In Demand', color: 'green' },
    { icon: 'security', title: 'CCTV Installation', desc: 'Complete security camera systems with remote monitoring setup.', price: 'From KSh 8,000', rating: 4.9, badge: 'New', color: 'gold' },
  ];
  
  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-tag">Featured Services</div>
          <h2 className="section-title">Top Rated <span style={{ color: 'var(--primary-green)' }}>Services</span></h2>
          <p className="section-subtitle mx-auto">Hand-picked services with the highest customer satisfaction ratings.</p>
        </div>
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="service-card">
                <div className="service-image" style={{ 
                  background: service.color === 'gold' 
                    ? 'linear-gradient(135deg, var(--gold-light), var(--gold))' 
                    : 'linear-gradient(135deg, var(--primary-green), var(--forest-green))' 
                }}>
                  <Icon name={service.icon} />
                </div>
                <div className="service-content">
                  <span className="service-badge">{service.badge}</span>
                  <h5>{service.title}</h5>
                  <p>{service.desc}</p>
                  <div className="service-footer">
                    <div>
                      <span className="service-price">{service.price}</span>
                      <div className="service-rating">
                        <Icon name="star" />
                        <span>{service.rating}</span>
                      </div>
                    </div>
                    <button className="btn-book" onClick={onQuoteClick}>Book Now</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = ({ onProviderClick }) => (
  <section className="cta-section">
    <div className="container">
      <div className="cta-card">
        <Icon name="engineering" style={{ position: 'absolute', top: '-30px', right: '-30px', fontSize: '200px', color: 'rgba(0,0,0,0.05)', transform: 'rotate(-15deg)' }} />
        <div className="cta-content">
          <span className="cta-tag">Become a FundiSwift Pro</span>
          <h3>Are You a Service Professional?</h3>
          <p>Join Kenya's fastest-growing service marketplace. Get more clients, build your reputation, and grow your business with FundiSwift.</p>
          <span className="btn-cta" onClick={onProviderClick}>
            Register as a Provider <i className="fas fa-arrow-right"></i>
          </span>
        </div>
      </div>
    </div>
  </section>
);

// Why Us Section
const WhyUsSection = () => {
  const features = [
    { icon: 'verified_user', title: 'Verified Professionals', desc: 'Every service provider is thoroughly vetted and background-checked before joining our platform.' },
    { icon: 'schedule', title: 'Quick Response', desc: 'Get connected to available professionals within minutes. Same-day service available.' },
    { icon: 'payments', title: 'Transparent Pricing', desc: 'No hidden fees. Get upfront quotes before any work begins. Pay securely through the app.' },
    { icon: 'support_agent', title: '24/7 Support', desc: 'Our customer support team is always ready to help you with any questions or concerns.' },
  ];
  
  return (
    <section className="why-section" id="why-us">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-tag">Why FundiSwift</div>
          <h2 className="section-title">Why Choose <span style={{ color: 'var(--primary-green)' }}>Us?</span></h2>
          <p className="section-subtitle mx-auto">We're not just another service platform — we're your trusted partner.</p>
        </div>
        <div className="row g-4">
          {features.map((feature, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="feature-card">
                <div className="feature-icon">
                  <Icon name={feature.icon} />
                </div>
                <h5>{feature.title}</h5>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  const testimonials = [
    { 
      initials: 'JM', 
      name: 'James Mutua', 
      location: 'Nairobi, Kenya', 
      text: '"FundiSwift saved me when I had a burst pipe at midnight. The plumber arrived within 45 minutes and fixed everything professionally. Highly recommend!"',
      gradient: 'var(--primary-green), var(--forest-green)'
    },
    { 
      initials: 'AW', 
      name: 'Aisha Wanjiku', 
      location: 'Mombasa, Kenya', 
      text: '"The deep cleaning service was exceptional. My house looks brand new. The team was punctual, professional, and used quality products. Will definitely book again!"',
      gradient: 'var(--gold-light), var(--gold)'
    },
    { 
      initials: 'DO', 
      name: 'David Ochieng', 
      location: 'Kisumu, Kenya', 
      text: '"As a business owner, I needed reliable electrical work for my office. FundiSwift connected me with an excellent electrician who completed the job on time."',
      gradient: 'var(--primary-green), var(--forest-green)'
    },
  ];
  
  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-tag">Testimonials</div>
          <h2 className="section-title">What Our <span style={{ color: 'var(--primary-green)' }}>Clients Say</span></h2>
          <p className="section-subtitle mx-auto">Don't just take our word for it — hear from our satisfied customers.</p>
        </div>
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div className="col-lg-4" key={index}>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar" style={{ background: `linear-gradient(135deg, ${testimonial.gradient})` }}>
                    {testimonial.initials}
                  </div>
                  <div className="testimonial-info">
                    <h5>{testimonial.name}</h5>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
                <div className="testimonial-rating">
                  {[1,2,3,4,5].map(i => <Icon key={i} name="star" />)}
                </div>
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Safety Section
const SafetySection = () => {
  const safetyItems = [
    { icon: 'shield', title: 'Background Verified', desc: 'All professionals undergo comprehensive background checks.' },
    { icon: 'verified', title: 'Licensed & Insured', desc: 'Service providers are fully licensed and insured.' },
    { icon: 'handshake', title: 'Satisfaction Guarantee', desc: "Not happy? We'll make it right or refund your payment." },
  ];
  
  return (
    <section className="safety-section">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-5">
            <div className="section-tag" style={{ color: 'var(--gold)' }}>Your Safety Matters</div>
            <h2 className="section-title">Your Safety is Our <span style={{ color: 'var(--gold)' }}>Priority</span></h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: '2rem' }}>
              We go above and beyond to ensure that every service provided through FundiSwift is safe, reliable, and professional.
            </p>
            <div className="d-grid gap-3">
              {safetyItems.map((item, index) => (
                <div className="safety-card" key={index}>
                  <div className="safety-icon">
                    <Icon name={item.icon} />
                  </div>
                  <div>
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-7">
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              borderRadius: '30px', 
              padding: '3rem', 
              backdropFilter: 'blur(10px)' 
            }}>
              <div className="row g-4 text-center">
                <div className="col-6 col-md-3">
                  <div style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--gold)' }}>10K+</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>Happy Customers</div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--gold)' }}>500+</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>Verified Pros</div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--gold)' }}>50+</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>Service Types</div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--gold)' }}>4.9</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>Average Rating</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// App Promo Section
const AppPromoSection = () => (
  <section className="app-section">
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-6">
          <div className="app-tag">
            <Icon name="smartphone" />
            Download Our App
          </div>
          <h2>Get FundiSwift on Your Phone</h2>
          <p>Book services, track progress, and manage all your home maintenance needs from the palm of your hand.</p>
          <ul className="app-features">
            <li><Icon name="check_circle" /> Real-time service tracking</li>
            <li><Icon name="check_circle" /> Instant booking & payments</li>
            <li><Icon name="check_circle" /> Exclusive app-only deals</li>
            <li><Icon name="check_circle" /> Service history & reminders</li>
          </ul>
          <div className="app-buttons">
            <span className="btn-app">
              <i className="fab fa-google-play"></i>
              <span><small>GET IT ON</small>Google Play</span>
            </span>
            <span className="btn-app">
              <i className="fab fa-apple"></i>
              <span><small>Download on the</small>App Store</span>
            </span>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={{ 
            background: 'linear-gradient(135deg, rgba(35, 123, 10, 0.3), rgba(46, 125, 50, 0.4))', 
            borderRadius: '30px', 
            height: '400px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            <i className="fas fa-mobile-alt" style={{ fontSize: '6rem', color: 'white', opacity: 0.5 }}></i>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Contact Section
const ContactSection = () => (
  <section className="contact-section" id="contact">
    <div className="container">
      <div className="text-center mb-5">
        <div className="section-tag">Get In Touch</div>
        <h2 className="section-title">Contact <span style={{ color: 'var(--primary-green)' }}>Us</span></h2>
        <p className="section-subtitle mx-auto">Have questions? We're here to help 24/7.</p>
      </div>
      <div className="row g-4">
        <div className="col-lg-4">
          <div className="feature-card" style={{ background: 'linear-gradient(135deg, rgba(35, 123, 10, 0.05), rgba(46, 125, 50, 0.08))', borderRadius: '20px' }}>
            <div className="feature-icon"><Icon name="phone" /></div>
            <h5>Call Us</h5>
            <p><a href="tel:+254 797 730 550" style={{ color: 'var(--primary-green)', textDecoration: 'none', fontWeight: 600 }}>+254 797 730 550</a></p>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="feature-card" style={{ background: 'linear-gradient(135deg, rgba(232, 163, 61, 0.1), rgba(245, 166, 35, 0.15))', borderRadius: '20px' }}>
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg, rgba(232, 163, 61, 0.2), rgba(245, 166, 35, 0.25))' }}>
              <Icon name="email" style={{ color: 'var(--gold)' }} />
            </div>
            <h5>Email Us</h5>
            <p><a href="mailto:info@fundiswift.co.ke" style={{ color: 'var(--gold)', textDecoration: 'none', fontWeight: 600 }}>info@fundiswift.co.ke</a></p>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="feature-card" style={{ background: 'linear-gradient(135deg, rgba(35, 123, 10, 0.05), rgba(46, 125, 50, 0.08))', borderRadius: '20px' }}>
            <div className="feature-icon"><Icon name="location_on" /></div>
            <h5>Visit Us</h5>
            <p>Park Suites, 44 Parklands Rd, Nairobi</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Footer Component
const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="row g-4">
        <div className="col-lg-4">
          <div className="footer-brand">
            <Logo />
            <p>FundiSwift is Kenya's leading unified home service marketplace, connecting customers with verified professionals.</p>
          </div>
        </div>
        <div className="col-lg-2 col-md-6">
          <h5 className="footer-title">Services</h5>
          <ul className="footer-links">
            <li><a href="#services">Plumbing</a></li>
            <li><a href="#services">Electrical</a></li>
            <li><a href="#services">Cleaning</a></li>
            <li><a href="#services">Auto Repair</a></li>
          </ul>
        </div>
        <div className="col-lg-2 col-md-6">
          <h5 className="footer-title">Company</h5>
          <ul className="footer-links">
            <li><a href="#about">About Us</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="#contact">Contact</a></li>
            <li><a href="#">Careers</a></li>
          </ul>
        </div>
        <div className="col-lg-2 col-md-6">
          <h5 className="footer-title">Legal</h5>
          <ul className="footer-links">
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms of Service</a></li>
            <li><a href="#">Cookie Policy</a></li>
          </ul>
        </div>
        <div className="col-lg-2 col-md-6">
          <h5 className="footer-title">Connect</h5>
          <div className="footer-social">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 FundiSwift. All rights reserved.</p>
        <p>Made with love in Kenya</p>
      </div>
    </div>
  </footer>
);

// Main App Component
function App() {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showProviderModal, setShowProviderModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <div className="App">
      <Navbar 
        onLoginClick={() => setShowLoginModal(true)}
        onQuoteClick={() => setShowQuoteModal(true)}
        onProviderClick={() => setShowProviderModal(true)}
      />
      
      <HeroSection onExploreServices={scrollToServices} />
      <AboutSection />
      <HowItWorksSection />
      <CategoriesSection onQuoteClick={() => setShowQuoteModal(true)} />
      <ServicesSection onQuoteClick={() => setShowQuoteModal(true)} />
      <CTASection onProviderClick={() => setShowProviderModal(true)} />
      <WhyUsSection />
      <TestimonialsSection />
      <SafetySection />
      <AppPromoSection />
      <ContactSection />
      <Footer />
      
      <Modal 
        isOpen={showQuoteModal} 
        onClose={() => setShowQuoteModal(false)} 
        title="Get a Free Quote" 
        icon="description"
      >
        <QuoteForm onClose={() => setShowQuoteModal(false)} />
      </Modal>
      
      <Modal 
        isOpen={showProviderModal} 
        onClose={() => setShowProviderModal(false)} 
        title="Join as a Service Provider" 
        icon="engineering"
      >
        <ProviderForm onClose={() => setShowProviderModal(false)} />
      </Modal>
      
      <LoginSelectionModal 
        isOpen={showLoginModal} 
        onClose={() => setShowLoginModal(false)}
        onSelectType={(type) => console.log('Selected:', type)}
      />
    </div>
  );
}

export default App;
